import React from "react";
import { Card, Col } from "react-bootstrap";
import SubscriptionsButton from "components/Subscriptions/SubscriptionsButton/SubscriptionsButton";
import { useAutoSubscribePublication } from "lib/hooks/useSubscriptions/useAutoSubscribePublication";
import { features } from "app/features";
import chatbot from "../../chatbot/assets/NaiRa_Blue-Outline_BAR.svg";
import aiSumHover from "./assets/icons/NaiRa_SUM_BUT_HOVER.svg";
import aiSumOn from "./assets/icons/NaiRa_SUM_BUT_ON.svg";


import {
  Analysts,
  Title,
  PublicationDate,
  Synopsis,
  Tags,
  TopStory,
  FileTypeIcon,
} from "../TileView/PublicationCardParts";
import { ShareButton } from "../ShareMenu/ShareButton";
import pubStyles from "./PublicationCard.module.scss";
import { useShowAiSummary } from "../../lib/hooks/useShowAiSummary";
import { auditAiSummaryClick } from "lib/analytics/auditEvents";

export function PublicationCard({ publication, styles, isTopStory, lang }) {
  useAutoSubscribePublication(publication);
  const showAiSummary = useShowAiSummary(publication);

 const openAISidebar = () => {
    auditAiSummaryClick(publication.id);
    window.dispatchEvent(new CustomEvent('open-naira-chat', { detail: { tab: 1, publicationId: publication.id } }));
  }

  return (
    <Col
      key={publication.id}
      lg={publication.lg || 4}
      md={publication.md || 6}
      sm={publication.sm || 6}
      xs={12}
      className="d-flex pb-3 px-2"
    >       
      <Card className={`${styles.card || ""} ${pubStyles["research-report-card"]} w-100 rounded-0 shadow`} style={styles.cardStyle} lang={lang}>
        {/* <div className={`${pubStyles["hover-hint-top"]}`}>AI Summary</div>
        <div className={`${pubStyles["hover-hint-bottom"]}`}>Subscribe</div> */}
        {showAiSummary && (
          <button className={`${pubStyles["ai-summary-btn"]}`} onClick={() => openAISidebar()}>
            <img src={aiSumHover} alt="AI Summary" className={pubStyles["btn-icon-hover"]} />
            <img src={aiSumOn} alt="AI Summary" className={pubStyles["btn-icon-on"]} />
          </button>
        )}
        <Card.Header
          className={`${styles.header || ""} border-bottom-0 ${pubStyles["card-header-relative"]}`}
          style={showAiSummary ? { paddingRight: "122px", minHeight: "42px" } : undefined}>
          {isTopStory && <TopStory />}
          <Analysts lang={lang} {...publication} styles={styles} />          
        </Card.Header>

        <Card.Body className={`${styles.body} py-0 ${pubStyles.synopsis}`}>
          <Card.Title className={`${styles.title || ""}`}>
            <Title {...publication} />
          </Card.Title>
          <Synopsis {...publication} styles={styles} />
        </Card.Body>

        <Card.Footer className={`border-top-0 ${styles.footer || ""}`}>
          <Tags {...publication} lang={lang} />
          <div className={pubStyles.actionButtons} >
            <PublicationDate {...publication} />
            <FileTypeIcon {...publication} />
          {features.subscriptionButton && <SubscriptionsButton publication={publication} customClass="ml-auto" />}
          <ShareButton publication={publication} customClass={pubStyles.shareButton} />
          </div>
        </Card.Footer>
      </Card>
    </Col>
  );
}
